import { render, staticRenderFns } from "./alertDefault.vue?vue&type=template&id=242634c4"
import script from "./alertDefault.vue?vue&type=script&lang=js"
export * from "./alertDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports